import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ICompleteRemoteRefreshAgentWorkflowParams {
  workflowId: string;
}

export class CompleteRemoteRefreshAgentWorkflowRequest
extends Request<ICompleteRemoteRefreshAgentWorkflowParams, IResult> {
  constructor(params: ICompleteRemoteRefreshAgentWorkflowParams) {
    super('completeRemoteRefreshAgentWorkflow', params);
  }
}
